import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { ProdutividadeOperador } from '../../types/pessoas';
import { produtividadeOperadorService } from '../../services';

const columns: ResourceColumn<ProdutividadeOperador>[] = [
  { header: "Operador", accessor: "operador_nome" },
  { header: "Data", accessor: "data_referencia" },
  { header: "Horas", accessor: "horas_trabalhadas" },
  { header: "Produção/Refugo", render: (item) => item.quantidade_produzida + "/" + item.quantidade_refugada },
  { header: "Apontamento", accessor: "apontamento_info" }
];

export const ProdutividadeOperadorListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Produtividade por operador"
    description="Indicadores individuais coletados."
    columns={columns}
    service={produtividadeOperadorService}
    createPath="/admin/pessoas/produtividade-operador/novo"
      onEdit={(item) => item.id && navigate("/admin/pessoas/produtividade-operador/editar", { state: { record: item } })}
  />
  );
};